import {PortExposuresItemChunk} from "../chunks/types/PortExposuresItemChunk";
import {portExposureBodyChunkToChildPortRef} from "./portExposureBodyChunkToChildPortRef";
import {ChildPortRef} from "./types/ChildPortRef";

export function portExposuresItemChunkToChildPortRef(
  portExposuresItemChunk: PortExposuresItemChunk
): ChildPortRef<any, any> {
  const {
    captures: {
      1: portExposureBodyChunk
    }
  } = portExposuresItemChunk;
  return portExposureBodyChunkToChildPortRef(portExposureBodyChunk);
}
